var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStoreIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 143,
    viewBox: "0 0 209 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56844 114.087C-23.5937 74.752 57.2047 64.1731 105.2 33.9763C131.353 17.5213 143.315 -0.479054 165.919 0.00973834C212.131 1.00901 214.021 84.911 204.208 99.9835C167.205 156.817 19.0527 130.367 6.56844 114.087Z",
    fill: "#D9EFFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.525 29.125L16.6875 84.4346L24.8325 85.8734L20.9995 124.718L30.3423 126.477L68.3123 133.95L100.773 140.544L107.48 141.343L163.297 128.555L199.071 118.644L196.676 97.5432H200.668L120.496 40.4747L104.525 29.125Z",
    fill: "#071A20",
    stroke: "#0D2A38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.485 76.9067C80.8991 82.5817 39.1672 94.0278 36.9234 94.4159L34.5078 123.919L101.485 136.303H106.8L119.077 133.5L160.541 125.663L199.219 118.399V117.919L197.458 104.672L105.257 75.9375L101.485 76.9067Z",
    fill: "#EAF2F7",
    stroke: "#0D2A38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3645 114.641L34.4062 123.753L61.0771 129.507L101.323 136.541H106.912L153.866 126.63L199.382 118.477L198.584 114.641L104.517 118.477L35.3645 114.641Z",
    fill: "#A1CFDA",
    stroke: "#0D2A38"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0234 124.637L25.7747 125.515L32.4823 126.794L35.357 93.8648L104.59 72.6037L197.139 104.335L196.42 97.0616L156.254 72.6037L104.59 44.7891L56.2785 68.3676L24.9362 85.6722L21.0234 124.637Z",
    fill: "#90C2DF",
    stroke: "#0D2A38"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.402 136.306L34.965 123.837L32.8089 123.437L32.25 126.874L66.9857 133.668L106.274 141.581L159.695 129.352L199.302 118.962V118.242L161.691 125.196L156.501 126.235L135.899 130.152L120.168 133.109L107.232 136.306H101.402Z",
    fill: "#716F6E",
    stroke: "#0D2A38"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.677 72.6016L102.121 73.4006L100.844 141.579L105.076 142.218L107.472 141.579L108.03 73.8008L104.677 72.6016Z",
    fill: "#0D2A38",
    stroke: "#0D2A38"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.589 58.1286L123.281 54.8516V78.9094L121.125 78.35L121.524 137.656L123.76 138.056L130.388 136.218L129.589 58.1286Z",
    fill: "#0D2A38",
    stroke: "#0D2A38"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M159.852 91.7059L162.008 128.073L163.764 128.712L166.479 128.073L164.403 93.1447L163.764 76.9195L162.567 76.1198L161.289 75.6406V86.5904V92.1851L159.852 91.7059Z",
    fill: "#0D2A38",
    stroke: "#0D2A38"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M178.777 124.372L177.18 97.7766H178.777L178.378 92.1016L177.819 85.8672L179.895 86.9861L180.694 94.6594L182.849 124.372L181.093 124.932L178.777 124.372Z",
    fill: "#0D2A38",
    stroke: "#0D2A38"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M187.398 101.297L189.714 121.997L191.87 121.598L189.155 92.3444L188.037 91.625L187.398 92.3444L188.037 101.297H187.398Z",
    fill: "#0D2A38",
    stroke: "#0D2A38"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5859 129.664L49.0214 89.6204L50.8181 89.1406L48.5423 126.467H47.664V129.864L46.5859 129.664Z",
    fill: "#0D2A38",
    stroke: "#0D2A38"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2656 133.466C66.9837 117.64 68.2379 84.4063 68.3015 83.8309L70.5774 83.0312L68.6612 130.069H67.4631V133.745L66.2656 133.466Z",
    fill: "#0D2A38",
    stroke: "#0D2A38"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5567 75.9348L71.9379 64.4453L72.896 76.9142L44.4688 86.5054L45.5567 75.9348Z",
    fill: "#C6E1F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M134.68 65.1484L158.955 77.7772V86.7294L134.68 76.6583V65.1484Z",
    fill: "#C6E1F0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreIcon);
export default __webpack_public_path__ + "static/media/store-icon.5a96f6d9d4c4fb08df513f47a1bed5bc.svg";
export { ForwardRef as ReactComponent };